import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Route, useHistory, useLocation } from 'react-router-dom';
import Navbar from '@rd-web-markets/market/dist/layout/Navbar/Navbar';
import Toast from '@rd-web-markets/shared/dist/util/toast/Toast';
import * as QueryString from 'query-string';
import ErrorHandler from '@components/util/ErrorHandler';
import UnexpectedSynchronousErrorBoundary from './UnexpectedSynchronousErrorBoundary';
import { translationsService } from '@services/translations.service';
import { APP_FOOTER_TEXT, APP_RELEASE_VERSION, USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import ToastContainer from '@rd-web-markets/shared/dist/util/toast/ToastContainer';
import { redirectUserToAnotherAccountTypeRouteIfNecessary } from '@rd-web-markets/shared/dist/util/redirectUser';
import { useLoadTranslationsWithTooltips } from 'src/hooks/useLoadTranslationsWithTooltips';

const NavbarV2 = USE_V2_DESIGN
  ? require('@rd-web-markets/market/dist/layout/Navbar/NavbarV2').default
  : null;

export const ManagerRoute = ({ component: Component, ...rest }) => {
  const user = useSelector((state) => state.auth.user);
  const [show, setShow] = React.useState(false);
  const [toastVariant, setToastVariant] = React.useState('success');
  const [message, setMessage] = React.useState(false);
  const history = useHistory();
  const location = useLocation();

  const isV2 = USE_V2_DESIGN;

  const handleToaster = (m, variant) => {
    variant ||= 'success';
    setShow(true);
    setMessage(m);
    setToastVariant(variant);
  }

  useLoadTranslationsWithTooltips(user, 'manager', translationsService);

  return (
    <Route {...rest} render={(props) => {
      if (user && user.account_type === 'manager') {
        return (
          <>
            <ErrorHandler>
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  right: 0,
                  zIndex: 9999,
                  width: 'max-content'
                }}
              >
                <ToastContainer /> {/* uses redux */}
                <Toast show={show} message={message} variant={toastVariant} onClose={() => setShow(false)}/>
              </div>

              {isV2
                ? <NavbarV2
                    userRole="manager"
                    basename={rest.basename}
                    {...props}
                  />
                : <Navbar userRole="manager" basename={rest.basename} {...props} />
              }

              <div
                className="wrapper"
                id="content-wrapper"
                style={isV2 ? { left: 0 } : undefined}
              >
                <Container fluid>
                  <UnexpectedSynchronousErrorBoundary>
                    <Component {...props} handleToaster={handleToaster} accountType={user.account_type} />
                    <div className="text-muted text-center" dangerouslySetInnerHTML={{ __html: `&copy; ${APP_FOOTER_TEXT}` }} >
                    </div>
                  </UnexpectedSynchronousErrorBoundary>
                </Container>
              </div>
            </ErrorHandler>
          </>
        );
      }
      else {
        redirectUserToAnotherAccountTypeRouteIfNecessary(user)
      }
    }} />
  )
}
